import React, {useEffect, useState} from 'react';
import {ENV} from "@environments/environment";

const {AWS_S3_FILE_UPLOAD, API_URL, GG_KEY} = ENV

const Files = () => {


    useEffect( () => {
        let location = window.location;
        let url = location.pathname + location.search;
        let type = url ? url.split('/')[2] : location.search.slice(2);
        let fileName = url ? url.split('/')[3] : location.search.slice(3);
        window.open(`${AWS_S3_FILE_UPLOAD}/${fileName}.${type}`, "_self");
    }, []);

  return (
    <>
    </>
  );
}

export default Files;
